import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import RouteLoading from '@shared/routing/RouteLoading'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

const TeamsLinkRoutes = lazyWithRetries(() => import('.'))

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.teamsLink(),
    element: (
      <Suspense fallback={<RouteLoading />}>
        <TeamsLinkRoutes />
      </Suspense>
    ),
  },
]

export default routes
